<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-08-05 17:20:40
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header
              @back="goBack"
              :content="categoryId == '' ? '新增分类' : '编辑分类'"
            >
            </el-page-header>
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="分类名称" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入分类名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="跳转地址" prop="link">
              <el-input
                v-model="ruleForm.link"
                placeholder="请输入跳转地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="上级分类" prop="pid">
              <el-cascader
                style="margin-right: auto"
                :props="cateProps"
                :show-all-levels="false"
                v-model="selectData"
                :options="list"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="归属" prop="pageModule">
              <el-select
                v-model="ruleForm.pageModule"
                placeholder="请选择"
                clearable
                style="margin-right: auto"
              >
                <el-option label="首页(开屏广告)" value="1"></el-option>
                <el-option label="文章分类" value="2"></el-option>
                <el-option label="标签分类" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="ruleForm.sort"
                placeholder="请输入排序"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="close()">取消</el-button>
              <el-button
                @click="submitForm('ruleForm')"
                class="btn"
                style="margin-right: auto"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        name: "",
        sort: "",
        link: "",
        pid: "",
        pageModule: "",
      },
      rules: {
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        sort: [{ required: true, message: "必选项", trigger: "blur" }],
        pid: [{ required: true, message: "必选项", trigger: "change" }],
        pageModule: [{ required: true, message: "必选项", trigger: "change" }],
      },
      categoryId: "",
      list: [],
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      selectData: [],
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    handleChange(val) {
      this.ruleForm.pid = val[val.length - 1];
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            name: this.ruleForm.name,
            moreUrl: this.ruleForm.link,
            sort: this.ruleForm.sort,
            pid: this.ruleForm.pid,
            pageModule: this.ruleForm.pageModule,
          };
          if (this.categoryId == "") {
            this.$axios
              .post(`/admapi/categories/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch()
              .finally();
          } else {
            param.id = this.categoryId;
            this.$axios
              .post(`/admapi/categories/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch()
              .finally();
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    close() {
      this.$router.go(-1);
    },
    statusChange() {
      if (this.ruleForm.role.length > 1) {
        this.ruleForm.role.splice(0, 1);
      }
    },
    getDetail() {
      this.$axios
        .post(`/admapi/categories/get/${this.categoryId}`)
        .then(({ data }) => {
          console.log(data.pageModule);
          this.ruleForm.name = data.name;
          this.ruleForm.sort = data.sort;
          this.ruleForm.link = data.moreUrl;
          this.ruleForm.pid = data.pid;
          this.selectData = [data.pid];
          this.ruleForm.pageModule = JSON.stringify(data.pageModule);
        })
        .catch()
        .finally();
    },
    getList() {
      let param = {
        page: 1,
        pageSize: 1000,
      };
      this.$axios
        .post(`/admapi/categories/treelist`, param)
        .then(({ data }) => {
          data.push({
            id: 0,
            name: "顶级",
          });
          this.list = data;
          if (this.$route.query.id) {
            this.categoryId = this.$route.query.id;
            this.getDetail();
          }
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
</style>
